import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../help-service";

@Component({
  selector: "app-tnc",
  templateUrl: "./tnc.component.html",
  styleUrls: ["./tnc.component.css"],
})
export class TncComponent implements OnInit {
  constructor(
    private helpService: HelpService,
    public fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  tncForm = this.fb.group({
    pic: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    name: ["", Validators.required],
    phonenumber: [
      "",
      [
        Validators.required,
        Validators.pattern("^((\\+62-?)|0)?[- +()0-9]+"),
        Validators.minLength(10),
        Validators.maxLength(15),
      ],
    ],
    soldto: ["", Validators.required],
    nik: [
      "",
      Validators.required,
      Validators.minLength(15),
      Validators.maxLength(16),
    ],
    address: ["", Validators.required],
    city: ["", Validators.required],
  });

  ngOnInit(): void {}

  get f() {
    return this.tncForm.controls;
  }

  submitForm() {}
}
